<template>
  <section class="CarouselProductBannersCmp">
    <div :class="['container', { 'px-0': xsOnly }]">
      <div class="row justify-content-center">
        <div class="col-12">
          <slider-cmp-extended
            :class="[{ 'swiper-button-hidden': hideNavigationArrow }]"
            :data-bootstrap-container-classes="['container-fluid', 'px-0']"
            :data-component-slides="true"
            :data-options="{
              observer: true,
            }"
          >
            <template slot="custom-swipe-icon">
              <slot name="custom-swipe-icon" />
            </template>
            <template slot="components">
              <slot name="carousel" />
            </template>
          </slider-cmp-extended>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderCmpExtended from './slider-cmp-extended';
import { castPropToType } from '@/helpers/cms-support';
import { xsOnly } from '@/helpers/breakpoints';

export default {
  name: 'CarouselProductBannersCmp',
  components: { SliderCmpExtended },
  props: {
    dataHideNavigationArrow: {
      type: [Boolean, String],
      default: false,
    },
  },
  setup() {
    return { castPropToType, xsOnly };
  },
  computed: {
    hideNavigationArrow() {
      return this.dataHideNavigationArrow
        ? this.castPropToType(this.dataHideNavigationArrow, 'boolean')
        : null;
    },
  },
};
</script>

<style lang="scss" scoped>
.CarouselProductBannersCmp {
  ::v-deep .SliderCmpExtended {
    --swiper-button-size: 44px;
    --swiper-navigation-size: 80px;

    &.swiper-button-hidden {
      .swiper-button-prev,
      .swiper-button-next {
        display: none;
      }
    }

    .swiper-button-prev,
    .swiper-button-next {
      display: none;
      top: calc(
        50% - 41px
      ); // 41px is the height of the pagination divided by 2
      width: var(--swiper-button-size);
      height: var(--swiper-button-size);
      background: $color-blue-10;
      color: $color-dark-blue;
      cursor: pointer;

      @include media-breakpoint-up(md) {
        display: flex;
      }

      &::after {
        transform: scale(0.33333333);
        font-weight: bolder;
      }

      &.swiper-button-disabled {
        display: none;
      }
    }

    .swiper-button-prev {
      right: calc(
        100% - var(--swiper-button-size) - (var(--slider-outline) * 2)
      );
      left: auto;

      &::after {
        padding-right: 5px;
      }
    }

    .swiper-button-next {
      right: auto;
      left: calc(
        100% - var(--swiper-button-size) - (var(--slider-outline) * 2)
      );

      &::after {
        padding-left: 5px;
      }
    }

    .custom-swipe-icon {
      box-shadow: none;
    }

    .slider-content {
      padding-bottom: 82px;

      .swiper-container {
        background-color: $color-blue-10;

        @include media-breakpoint-up(md) {
          background-color: transparent;
        }

        .swiper-wrapper {
          .swiper-slide {
            height: auto;

            .SideBySideCmp {
              height: 100%;
              padding-top: 40px;
              padding-bottom: 40px;
              background-color: $color-blue-10;

              @include media-breakpoint-up(md) {
                border-radius: 8px;
              }

              .container {
                @include media-breakpoint-up(md) {
                  width: 100%;
                  max-width: none;
                  padding: 0;
                }
              }
            }
          }
        }

        .swiper-pagination {
          padding: 55px 0 15px;
        }
      }
    }
  }
}
</style>
